import { commonUtils } from '@/helpers/commonUtils'
import styles from './InviteLinkStatusDialog.module.less'
import { useTranslation } from 'react-i18next'
import AIcon from '@/components/A/AIcon/AIcon'
import { useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

type InvitationStatus = 'normal' | 'expired' | 'already_in' | null

function useInvitationStatus() {
  const [urlParams] = useSearchParams()
  const invitationStatus = urlParams.get('il') as InvitationStatus
  useEffect(() => {
    if (invitationStatus !== null) {
      setTimeout(() => {
        urlParams.delete('il')
        const url = new URL(window.location.href)
        url.search = urlParams.toString()
        /** 不刷新页面的情况下移除链接上的 il 参数 */
        window.history.replaceState({}, '', url.href)
      }, 5000)
    }
  }, [])
  return invitationStatus
}

function InviteLinkStatusDialog() {
  const { t } = useTranslation()
  const status = useInvitationStatus()
  const [open, setOpen] = useState(status !== null)

  return open ? (
    <div className={styles.inviteLinkStatusDialog}>
      <div className={styles.dialogContent}>
        <span className={styles.close} onClick={() => setOpen(false)}>
          <AIcon type='icon-line-global_close1'></AIcon>
        </span>
        <img
          className={styles.brand}
          src={commonUtils.getImagePath('loginPage/login-brand.png')}
          alt=''
        />
        {status === 'normal' && <p className={styles.title}>👏 {t('login.text1')}</p>}
        {status === 'already_in' && <p className={styles.title}>{t('login.text2')}</p>}
        {status === 'expired' && <p className={styles.title}>{t('login.text3')}</p>}
        {(status === 'normal' || status === 'already_in') && (
          <img
            className={styles.pic}
            src={commonUtils.getImagePath('loginPage/invitation-link-success.png')}
            alt=''
          />
        )}
        {status === 'expired' && (
          <img
            className={styles.pic}
            src={commonUtils.getImagePath('loginPage/invitation-link-expired.png')}
            alt=''
          />
        )}
        {(status === 'normal' || status === 'already_in') && (
          <p className={styles.desc}>{t('login.text1Desc')}</p>
        )}
        {status === 'expired' && <p className={styles.desc}>{t('login.text4')}</p>}
      </div>
    </div>
  ) : null
}

export default InviteLinkStatusDialog
